/**
 * Time formatting utilities
 * Converts between 24-hour and 12-hour time formats
 */

/**
 * Convert 24-hour time format to 12-hour format with AM/PM
 * @param {string} time24 - Time string in 24-hour format (e.g., "09:30", "13:00")
 * @returns {string} Time string in 12-hour format (e.g., "9:30AM", "1:00PM")
 */
export function formatTime(time24) {
  const [hours, minutes] = time24.split(':').map(Number);
  const period = hours >= 12 ? 'PM' : 'AM';
  const hours12 = hours % 12 || 12;
  return `${hours12}:${minutes.toString().padStart(2, '0')}${period}`;
}
